// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Radio_radio__SLIFg {
    display: inline-flex;
    flex-direction: row;
    gap: 8px
}

.Radio_radioContainer__izS8c {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    width: 24px !important;
}

.Radio_radioInput__k3ssS {
    position: absolute;;
    opacity: 0;
    height: 24px;
    width: 24px !important;
    margin: 0px !important;
    z-index: 1;
}

.Radio_radioDecorator__tKoo8 {
    border: 1px solid var(--toggle-toggle-off);
    height: 14px;
    width: 14px;
    border-radius: 50%;
    outline-offset: 1.5px;
}

.Radio_radioInput__k3ssS:focus-visible + .Radio_radioDecorator__tKoo8 {
    outline: 2px solid var(--toggle-toggle-focus);
}

.Radio_radioInput__k3ssS:hover:not(:disabled) + .Radio_radioDecorator__tKoo8 {
    border: 1px solid var(--toggle-toggle-off-hover);
}

.Radio_radioInput__k3ssS:checked + .Radio_radioDecorator__tKoo8 {
    background-color: var(--icon-always-white);
    border: 4px solid var(--toggle-toggle-on);
    height: 8px;
    width: 8px;
}

.Radio_radioInput__k3ssS:checked:hover:not(:disabled) + .Radio_radioDecorator__tKoo8 {
    border: 4px solid var(--toggle-toggle-on-hover);
}

.Radio_radioInput__k3ssS:disabled + .Radio_radioDecorator__tKoo8 {
    opacity: 0.5;
}

.Radio_label__HL2Z6 {
    margin-bottom: 0px !important;
    font-family: 'Open Sans';
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0%;
    color: var(--text-default)
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Radio/Radio.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,mBAAmB;IACnB;AACJ;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,0CAA0C;IAC1C,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,0CAA0C;IAC1C,yCAAyC;IACzC,WAAW;IACX,UAAU;AACd;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB;AACJ","sourcesContent":[".radio {\n    display: inline-flex;\n    flex-direction: row;\n    gap: 8px\n}\n\n.radioContainer {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    height: 24px;\n    width: 24px !important;\n}\n\n.radioInput {\n    position: absolute;;\n    opacity: 0;\n    height: 24px;\n    width: 24px !important;\n    margin: 0px !important;\n    z-index: 1;\n}\n\n.radioDecorator {\n    border: 1px solid var(--toggle-toggle-off);\n    height: 14px;\n    width: 14px;\n    border-radius: 50%;\n    outline-offset: 1.5px;\n}\n\n.radioInput:focus-visible + .radioDecorator {\n    outline: 2px solid var(--toggle-toggle-focus);\n}\n\n.radioInput:hover:not(:disabled) + .radioDecorator {\n    border: 1px solid var(--toggle-toggle-off-hover);\n}\n\n.radioInput:checked + .radioDecorator {\n    background-color: var(--icon-always-white);\n    border: 4px solid var(--toggle-toggle-on);\n    height: 8px;\n    width: 8px;\n}\n\n.radioInput:checked:hover:not(:disabled) + .radioDecorator {\n    border: 4px solid var(--toggle-toggle-on-hover);\n}\n\n.radioInput:disabled + .radioDecorator {\n    opacity: 0.5;\n}\n\n.label {\n    margin-bottom: 0px !important;\n    font-family: 'Open Sans';\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 21px;\n    letter-spacing: 0%;\n    color: var(--text-default)\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radio": `Radio_radio__SLIFg`,
	"radioContainer": `Radio_radioContainer__izS8c`,
	"radioInput": `Radio_radioInput__k3ssS`,
	"radioDecorator": `Radio_radioDecorator__tKoo8`,
	"label": `Radio_label__HL2Z6`
};
export default ___CSS_LOADER_EXPORT___;
